/**
 * Body editor for the copy_structure step: the new container name plus the
 * source container whose schema is cloned (values are not copied).
 */
import React from "react"
import { Tooltip } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons"
import { QueryBuilderStore } from "stores/queryBuilderStore"
import { CopyStructureStep } from "types/queryBuilder.types"
import SingleFieldSlot from "../SingleFieldSlot.component"
import { StepBodyProps } from "./stepBodyProps"

export interface CopyStructureStepBodyProps
  extends StepBodyProps<CopyStructureStep> {
  renameStep: QueryBuilderStore["renameTransformStep"]
  setCopySource: QueryBuilderStore["setCopyStructureSource"]
}

const CopyStructureStepBody: React.FC<CopyStructureStepBodyProps> = ({
  step,
  renameStep,
  setCopySource,
}) => (
  <>
    <input
      className="qc-recodes__name qc-mono"
      type="text"
      value={step.target}
      onChange={(e) => renameStep(step.id, e.target.value)}
      placeholder="New container name (use // for nesting)"
      aria-label="New container name"
    />
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">
        Clone structure from:
        <Tooltip
          title="Source QTable whose schema (fields and sub-containers) is copied. Values are NOT copied; every cell starts null. Use this to seed a parallel container that you'll then filter, blank, or modify separately."
          placement="top"
          overlayClassName="dataq-tooltip"
        >
          <FontAwesomeIcon
            icon={faCircleInfo}
            className="qc-step__field-info"
          />
        </Tooltip>
      </span>
      <SingleFieldSlot
        value={step.source}
        onChange={(v) => setCopySource(step.id, v)}
        placeholder="Drag the source container"
      />
    </div>
  </>
)

export default CopyStructureStepBody
